import React, { useEffect } from 'react';
const SITE_URL = 'https://azcitypac.com';
const SHARE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/aca6f416-3729-405e-a008-24d29474922f.jpg';
interface SeoProps {
  title: string;
  description: string;
  path?: string;
  type?: 'website' | 'article';
  image?: string;
  schema?: Record<string, unknown> | Array<Record<string, unknown>>;
}
function setMetaAttribute(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}
function setLink(rel: string, href: string) {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.rel = rel;
    document.head.appendChild(element);
  }
  element.href = href;
}
function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Arizona City Political Action Committee',
    alternateName: 'AZ City PAC',
    url: SITE_URL,
    description: 'A statewide coalition of mayors, councilmembers, business leaders, and community advocates protecting local control and strengthening Arizona cities and towns.',
    areaServed: {
      '@type': 'State',
      name: 'Arizona'
    },
    keywords: 'Arizona local control, Arizona cities and towns, municipal policy, zoning, land use, infrastructure, public safety, economic development',
    email: 'info@azcitypac.com'
  };
}
export function Seo({
  title,
  description,
  path = '/',
  type = 'website',
  image = SHARE_IMAGE,
  schema
}: SeoProps) {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path}`;
    const fullTitle = `${title} | AZ City PAC`;
    document.title = fullTitle;
    setMetaAttribute('name', 'description', description);
    setMetaAttribute('name', 'keywords', 'Arizona local control, Arizona cities and towns, municipal leadership, zoning, land use, infrastructure, public safety, economic development, AZ City PAC');
    setMetaAttribute('property', 'og:site_name', 'AZ City PAC');
    setMetaAttribute('property', 'og:type', type);
    setMetaAttribute('property', 'og:title', fullTitle);
    setMetaAttribute('property', 'og:description', description);
    setMetaAttribute('property', 'og:url', canonicalUrl);
    setMetaAttribute('property', 'og:image', image);
    setMetaAttribute('property', 'og:image:alt', 'Arizona skyline at sunset representing strong local communities');
    setMetaAttribute('name', 'twitter:card', 'summary_large_image');
    setMetaAttribute('name', 'twitter:title', fullTitle);
    setMetaAttribute('name', 'twitter:description', description);
    setMetaAttribute('name', 'twitter:image', image);
    setLink('canonical', canonicalUrl);
    const schemaElementId = 'az-city-pac-schema';
    let schemaElement = document.getElementById(schemaElementId) as HTMLScriptElement | null;
    if (!schemaElement) {
      schemaElement = document.createElement('script');
      schemaElement.id = schemaElementId;
      schemaElement.type = 'application/ld+json';
      document.head.appendChild(schemaElement);
    }
    const pageSchema = schema ?? {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: title,
      description,
      url: canonicalUrl
    };
    schemaElement.text = JSON.stringify([getOrganizationSchema(), pageSchema]);
  }, [description, image, path, schema, title, type]);
  return null;
}
export const seoConfig = {
  siteUrl: SITE_URL,
  shareImage: SHARE_IMAGE
};